<!-- Estándar de layout: contenido a 26 px del header y del sidebar (10 px de .main_content + tw-px-page / tw-pt-page) -->
<div class="tw-px-page tw-pt-page">
  <router-outlet></router-outlet>
</div>
